import {
    madnes_add_bitmap_text,
    madnes_add_text,
    madnes_set_bitmap_float, madnes_set_text_bounds
} from "../framework/src/engine/madnes/madnes_text";
import {
    madnes_add_group,
    madnes_add_img,
    madnes_add_sprite,
    madnes_add_to_group, madnes_set_img_center, madnes_set_pos, madnes_set_pos_x
} from "../framework/src/engine/madnes/madnes_object";
import {madnes_anim_add, madnes_anim_play} from "../framework/src/engine/madnes/madnes_anims";
import {bet, madnes_get_currtime, madnes_get_json} from "../framework/src/engine/madnes/madnes";
import {server_config, he_scale, wi, wi_scale, systemConfig} from "../framework/src/engine/madnes/madnes_variables";
import {madnes_add_to_render, madnes_rem_from_render} from "../framework/src/engine/madnes/madnes_render";
import {CONFIG_PARAMS} from "../framework/src/system/SystemConfig";

var settings_background_pos;
export function joker27plus_infomenu_init()
{
    settings_background_pos = 1;
    madnes_add_img("settings_background_1", "settings_background", -9999, -9999);
    madnes_add_img("settings_background_2", "settings_background", -9999, -9999);
    madnes_add_img("settings_background_3", "settings_background", -9999, -9999);

    madnes_add_group("settings_group_1");
    madnes_add_group("settings_group_2");
    madnes_add_group("settings_group_3");


    madnes_add_sprite("settings_symbol_joker", "symbol_Joker_blur", 310, 46, 1);
    madnes_add_to_group("settings_group_1", "settings_symbol_joker");

    madnes_add_sprite("settings_symbol_star", "symbol_Star_blur", 90, 340, 1);
    madnes_add_to_group("settings_group_1", "settings_symbol_star");

    madnes_add_sprite("settings_symbol_bar", "symbol_Bar_blur", 610, 340, 1);
    madnes_add_to_group("settings_group_1", "settings_symbol_bar");



    madnes_add_sprite("settings_symbol_melon", "symbol_Melon_blur", 92, 30, 1);
    madnes_add_to_group("settings_group_2", "settings_symbol_melon");

    madnes_add_sprite("settings_symbol_plum", "symbol_Plum_blur", 630, 46, 1);
    madnes_add_to_group("settings_group_2", "settings_symbol_plum");

    madnes_add_sprite("settings_symbol_bell", "symbol_Bell_blur", 570, 20, 1);
    madnes_add_to_group("settings_group_2", "settings_symbol_bell");



    madnes_add_sprite("settings_symbol_orange", "symbol_Orange_blur", 110, 360, 1);
    madnes_add_to_group("settings_group_2", "settings_symbol_orange");

    madnes_add_sprite("settings_symbol_dollar", "symbol_Dollar_blur", 40, 320, 1);
    madnes_add_to_group("settings_group_2", "settings_symbol_dollar");

    madnes_add_sprite("settings_symbol_cherry", "symbol_Cherry_blur", 624, 320, 1);
    madnes_add_to_group("settings_group_2", "settings_symbol_cherry");


    madnes_add_sprite("settings_symbol_joker2", "symbol_Joker_blur", 830, 398, 1);
    madnes_add_to_group("settings_group_3", "settings_symbol_joker2");

    madnes_anim_add("settings_symbol_joker", "stop", [1]); madnes_anim_play("settings_symbol_joker", "stop");
    madnes_anim_add("settings_symbol_star", "stop", [1]); madnes_anim_play("settings_symbol_star", "stop");
    madnes_anim_add("settings_symbol_bar", "stop", [1]); madnes_anim_play("settings_symbol_bar", "stop");
    madnes_anim_add("settings_symbol_melon", "stop", [1]); madnes_anim_play("settings_symbol_melon", "stop");
    madnes_anim_add("settings_symbol_plum", "stop", [1]); madnes_anim_play("settings_symbol_plum", "stop");
    madnes_anim_add("settings_symbol_bell", "stop", [1]); madnes_anim_play("settings_symbol_bell", "stop");
    madnes_anim_add("settings_symbol_orange", "stop", [1]); madnes_anim_play("settings_symbol_orange", "stop");
    madnes_anim_add("settings_symbol_dollar", "stop", [1]); madnes_anim_play("settings_symbol_dollar", "stop");
    madnes_anim_add("settings_symbol_cherry", "stop", [1]); madnes_anim_play("settings_symbol_cherry", "stop");
    madnes_anim_add("settings_symbol_joker2", "stop", [1]); madnes_anim_play("settings_symbol_joker2", "stop");


    madnes_add_sprite("settings_win_factor_field1", "win_factor_field", 600, 180, 1);
    madnes_add_to_group("settings_group_1", "settings_win_factor_field1");

    madnes_add_sprite("settings_win_factor_field2", "win_factor_field", 370, 464, 1);
    madnes_add_to_group("settings_group_1", "settings_win_factor_field2");

    madnes_add_sprite("settings_win_factor_field3", "win_factor_field", 900, 464, 1);
    madnes_add_to_group("settings_group_1", "settings_win_factor_field3");


    madnes_add_sprite("settings_win_factor_field4", "win_factor_field", 370, 176, 1);
    madnes_add_to_group("settings_group_2", "settings_win_factor_field4");

    madnes_add_sprite("settings_win_factor_field5", "win_factor_field", 900, 176, 1);
    madnes_add_to_group("settings_group_2", "settings_win_factor_field5");

    madnes_add_sprite("settings_win_factor_field6", "win_factor_field", 370, 460, 1);
    madnes_add_to_group("settings_group_2", "settings_win_factor_field6");

    madnes_add_sprite("settings_win_factor_field7", "win_factor_field", 900, 460, 1);
    madnes_add_to_group("settings_group_2", "settings_win_factor_field7");


    madnes_add_sprite("settings_free_spins_100", "info_number_100", 600, 90, 1);
    madnes_add_to_group("settings_group_1", "settings_free_spins_100");

    madnes_add_sprite("settings_free_spins_50", "info_number_50", 360, 376, 1);
    madnes_add_to_group("settings_group_1", "settings_free_spins_50");

    madnes_add_sprite("settings_free_spins_20", "info_number_20", 890, 376, 1);
    madnes_add_to_group("settings_group_1", "settings_free_spins_20");


    madnes_add_sprite("settings_free_spins_10", "info_number_10", 360, 90, 1);
    madnes_add_to_group("settings_group_2", "settings_free_spins_10");

    madnes_add_sprite("settings_free_spins_4", "info_number_4", 910, 90, 1);
    madnes_add_to_group("settings_group_2", "settings_free_spins_4");

    madnes_add_sprite("settings_free_spins_2", "info_number_2", 380, 376, 1);
    madnes_add_to_group("settings_group_2", "settings_free_spins_2");

    madnes_add_sprite("settings_free_spins_1", "info_number_1", 920, 376, 1);
    madnes_add_to_group("settings_group_2", "settings_free_spins_1");

    let arr = [1, 2, 4, 10, 20, 50, 100];
    let bot = 320;
    let top = 30;
    let left = 340;
    let right = 870;
    let mid = 600;
    let X   = [right, left, right, left, right, left, mid];
    let Y   = [bot, bot, top, top, bot, bot, top];
    if (systemConfig.get(CONFIG_PARAMS.LANGUAGE) === "es") {
        for (let i in arr) {
            madnes_add_sprite("info_giros_gratis_" + arr[i].toString(), "info_giros_gratis", X[i], Y[i], 1);
            madnes_add_to_group("settings_group_" + ((arr[i] > 10) ? "1" : "2"), "info_giros_gratis_" + arr[i].toString());
        }
    } else {
        for (let i in arr) {
            madnes_add_sprite("info_freespins_" + arr[i].toString(), "info_freespins", X[i], Y[i], 1);
            madnes_add_to_group("settings_group_" + ((arr[i] > 10) ? "1" : "2"), "info_freespins_" + arr[i].toString());
        }
    }


    var size = 80;

    madnes_add_bitmap_text("joker", "font_wintable",	840, 244, "0", size);
    madnes_set_img_center("joker", 1, 1);
    madnes_add_to_group("settings_group_1", "joker");

    madnes_add_bitmap_text("bar", "font_wintable",		610, 526, "0", size);
    madnes_set_img_center("bar", 1, 1);
    madnes_add_to_group("settings_group_1", "bar");

    madnes_add_bitmap_text("star", "font_wintable",		1144, 526, "0", size);
    madnes_set_img_center("star", 1, 1);
    madnes_add_to_group("settings_group_1", "star");


    madnes_add_bitmap_text("melone", "font_wintable",	610, 238, "0", size);
    madnes_set_img_center("melone", 1, 1);
    madnes_add_to_group("settings_group_2", "melone");

    madnes_add_bitmap_text("dollar", "font_wintable",	610, 522, "0", size);
    madnes_set_img_center("dollar", 1, 1);
    madnes_add_to_group("settings_group_2", "dollar");

    madnes_add_bitmap_text("bell", "font_wintable",		1142, 238, "0", size);
    madnes_set_img_center("bell", 1, 1);
    madnes_add_to_group("settings_group_2", "bell");

    madnes_add_bitmap_text("cherry", "font_wintable",	1142, 522, "0", size);
    madnes_set_img_center("cherry", 1, 1);
    madnes_add_to_group("settings_group_2", "cherry");

    madnes_set_pos("settings_group_1", -9999, -9999);
    madnes_set_pos("settings_group_2", -9999, -9999);
    madnes_set_pos("settings_group_3", -9999, -9999);

    var infotext = madnes_get_json("infotext");

    for(var i in infotext)
    {
        var x = infotext[i].position[0];
        var y = infotext[i].position[1];
        var page = infotext[i].page;
        var lineHeight0 = infotext[i].lineHeight;
        var lineHeight1 = infotext[i].lineHeight;
        var x_add = 0;
        var center = 0;

        if(infotext[i].center && infotext[i].center == 1)
        {
            center = 1;
        }

        var style0 = {
            "font": "32px Arial",
            "fill": "#ffffff",
            "fontWeight": "",
        };
        var style1 = {
            "font": "32px Arial",
            "fill": "#ffffff",
            "fontWeight": "",
        };

        if(infotext[i].fontSize && infotext[i].font)
        {
            style0.font = infotext[i].fontSize + "px " + infotext[i].font;
            style1.font = infotext[i].fontSize + "px " + infotext[i].font;
        }
        if(infotext[i].color)
        {
            style0.fill = infotext[i].color;
            style1.fill = infotext[i].color;
        }
        if(infotext[i].bold)
        {
            if(infotext[i].bold == 1)
            {
                style0.fontWeight = "bold";
                style1.fontWeight = "bold";
            }
            else if(infotext[i].bold == 1)
            {
                style0.fontWeight = "";
                style1.fontWeight = "";
            }
        }

        if(infotext[i].title.fontSize && infotext[i].title.font)
        {
            style0.font = infotext[i].title.fontSize + "px " + infotext[i].title.font;
        }
        if(infotext[i].title.lineHeight)
        {
            lineHeight0 = infotext[i].title.lineHeight;
        }
        if(infotext[i].title.color)
        {
            style0.fill = infotext[i].title.color;
        }
        if(infotext[i].title.bold)
        {
            if(infotext[i].title.bold == 1)
            {
                style0.fontWeight = "bold";
            }
            else if(infotext[i].title.bold == 1)
            {
                style0.fontWeight = "";
            }
        }

        if(infotext[i].body.fontSize && infotext[i].body.font)
        {
            style1.font = infotext[i].body.fontSize + "px " + infotext[i].body.font;
        }
        if(infotext[i].body.color)
        {
            style1.fill = infotext[i].body.color;
        }
        if(infotext[i].body.lineHeight)
        {
            lineHeight1 = infotext[i].body.lineHeight;
        }
        if(infotext[i].body.bold)
        {
            if(infotext[i].body.bold == 1)
            {
                style1.fontWeight = "bold";
            }
            else if(infotext[i].body.bold == 1)
            {
                style1.fontWeight = "";
            }
        }
        if(infotext[i].body.x_add)
        {
            x_add = infotext[i].body.x_add;
        }

        if(infotext[i]["boundsAlignH"]) {
            style0["boundsAlignH"] = infotext[i]["boundsAlignH"];
        }

        if(infotext[i]["boundsAlignH"]) {
            style0["boundsAlignV"] = infotext[i]["boundsAlignV"];
        }

        var line0 = 0;
        var line1 = 0;

        for(var j in infotext[i].title.content)
        {
            var text = infotext[i].title.content[j];
            var textName = "info_header_" + i + "_"  + j + "_" + line0;

            madnes_add_text(textName, x, y + line0 * lineHeight0, text, style0);
            if(center == 1)
            {
                madnes_set_img_center("info_header_" + i + "_"  + j + "_" + line0, 0.5, 0);
            }

            madnes_add_to_group("settings_group_" + ( page * 1 ), "info_header_" + i + "_"  + j + "_" + line0);

            if(infotext[i]["setTextBounds"]) {
                var tb = infotext[i]["setTextBounds"];
                madnes_set_text_bounds(textName, tb[0] * wi_scale, tb[1] * he_scale, tb[2] * wi_scale, tb[3] * he_scale);
            }

            line0++;
        }

        for(var j in infotext[i].body.content)
        {
            var text = infotext[i].body.content[j];
            madnes_add_text("info_body_" + i + "_"  + j + "_" + line1, x * 1 + x_add * 1, y + line0 * lineHeight0 + line1 * lineHeight1, text, style1);
            if(center == 1)
            {
                madnes_set_img_center("info_body_" + i + "_"  + j + "_" + line1, 0.5, 0);
            }
            madnes_add_to_group("settings_group_" + ( page * 1 ), "info_body_" + i + "_"  + j + "_" + line1);
            line1++;
        }

    }

    joker27plus_infomenu_update();
}

export var openinfo = false;

export function joker27plus_infomenu_open()
{
    settings_background_pos = 1;

    madnes_set_pos("settings_background_1", 0, 0);
    madnes_set_pos("settings_background_2", 2500, 0);
    madnes_set_pos("settings_background_3", 2500, 0);

    madnes_set_pos("settings_group_1", 0, 0);
    madnes_set_pos("settings_group_2", 2500, 0);
    madnes_set_pos("settings_group_3", 2500, 0);

    openinfo = true;
}

export function joker27plus_infomenu_close()
{
    madnes_set_pos("settings_background_1", -9999, -9999);
    madnes_set_pos("settings_background_2", -9999, -9999);
    madnes_set_pos("settings_background_3", -9999, -9999);

    madnes_set_pos("settings_group_1", -9999, -9999);
    madnes_set_pos("settings_group_2", -9999, -9999);
    madnes_set_pos("settings_group_3", -9999, -9999);

    openinfo = false;
}

export function joker27plus_infomenu_update()
{
    madnes_set_bitmap_float("cherry",	server_config.logic.symbols[0].factors[2] * bet, 190);
    madnes_set_bitmap_float("dollar",	server_config.logic.symbols[1].factors[2] * bet, 190);
    madnes_set_bitmap_float("bell",		server_config.logic.symbols[4].factors[2] * bet, 190);
    madnes_set_bitmap_float("melone",	server_config.logic.symbols[5].factors[2] * bet, 190);

    madnes_set_bitmap_float("star",		server_config.logic.symbols[6].factors[2] * bet, 190);
    madnes_set_bitmap_float("bar",		server_config.logic.symbols[7].factors[2] * bet, 190);
    madnes_set_bitmap_float("joker",	server_config.logic.symbols[8].factors[2] * bet, 190);
}

var move_start = 0;
var move_total = 250;
export function joker27plus_infomenu_left()
{
    if(!openinfo) return;
    if(joker27plus_infomenu_move_in == 0)
    {
        move_start = madnes_get_currtime();
        joker27plus_infomenu_move_in = 1;
        joker27plus_infomenu_move_dir = 1;
        madnes_add_to_render(joker27plus_infomenu_move);
    }
}

export function joker27plus_infomenu_right()
{
    if(!openinfo) return;
    if(joker27plus_infomenu_move_in == 0)
    {
        move_start = madnes_get_currtime();
        joker27plus_infomenu_move_in = 1;
        joker27plus_infomenu_move_dir = -1;
        madnes_add_to_render(joker27plus_infomenu_move);
    }
}

var joker27plus_infomenu_move_in = 0;
var joker27plus_infomenu_move_dir = 0;
var settings_background_pos2;

function joker27plus_infomenu_move()
{
    var difftime = madnes_get_currtime() - move_start;
    var end = 0;
    if(difftime > move_total)
    {
        difftime = move_total;
        end = 1;
    }

    settings_background_pos2 = settings_background_pos * 1 + ( joker27plus_infomenu_move_dir * -1 );
    if(settings_background_pos2 > 3)
    {
        settings_background_pos2 = 1;
    }
    if(settings_background_pos2 < 1)
    {
        settings_background_pos2 = 3;
    }

    var pos1 = wi * ( ( ( 100 / move_total ) * difftime ) / 100 ) * joker27plus_infomenu_move_dir;
    if(joker27plus_infomenu_move_dir < 0)
    {
        var pos2 = pos1 + wi;
    }
    else
    {
        var pos2 = wi * -1 + pos1;
    }

    madnes_set_pos_x("settings_background_" + settings_background_pos, pos1);
    madnes_set_pos_x("settings_background_" + settings_background_pos2, pos2);

    madnes_set_pos_x("settings_group_" + settings_background_pos, pos1);
    madnes_set_pos_x("settings_group_" + settings_background_pos2, pos2);

    if(end == 1)
    {
        madnes_rem_from_render(joker27plus_infomenu_move);

        madnes_set_pos_x("settings_background_" + settings_background_pos2, 0);
        madnes_set_pos_x("settings_background_" + settings_background_pos, 2500);

        madnes_set_pos_x("settings_group_" + settings_background_pos2, 0);
        madnes_set_pos_x("settings_group_" + settings_background_pos, 2500);

        settings_background_pos = settings_background_pos2;
        joker27plus_infomenu_move_in = 0;
        joker27plus_infomenu_move_dir = 0;
    }
}
